import { render, staticRenderFns } from "./CheckGoodsDialog.vue?vue&type=template&id=3c4ab44a&scoped=true"
import script from "./CheckGoodsDialog.vue?vue&type=script&lang=js"
export * from "./CheckGoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckGoodsDialog.vue?vue&type=style&index=0&id=3c4ab44a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ab44a",
  null
  
)

export default component.exports